import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import GpuForm from './gpu-form';



export default function AdminRequestDialog(props) {
  return (
      <Dialog open={props.open} onClose={props.close} aria-labelledby="form-dialog-title" scroll='body' maxWidth='xs' fullWidth>
        <DialogTitle id="form-dialog-title">
            { props.edit? <>Edit GPU</> : <>Add GPU</> }
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            submit for request for { props.edit? <>The GPU Update</> : <>The New GPU</> } 
          </DialogContentText>
          <GpuForm gpu={props.gpu} submit={props.submit} close={props.close}/>
        </DialogContent>
      </Dialog>
  );
}